import React from "react";
import { Button } from "reactstrap";

const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "ar", label: "Arabic" },
  { code: "fr", label: "French" },
  { code: "es", label: "Spanish" },
  { code: "pt_BR", label: "Portuguese (Brazil)" },
  { code: "de", label: "German" },
  { code: "it", label: "Italian" },
  { code: "id", label: "Indonesian" },
  { code: "vi", label: "Vietnamese" },
];

const TemplateListItem = ({ template, index, channel, onEdit }) => {
  const isEvenRow = index % 2 === 0;
  const isVoiceCall = channel === "PhoneSuite";
  const isWhatsApp = channel === "whatsapp";
  const isSMS = channel === "sms";
  const languageLabel = LANGUAGES.find((lang) => lang.code === template.language)?.label || "N/A";
  return (
    <div
      className="d-flex align-items-center px-3 py-3"
      style={{
        backgroundColor: isEvenRow ? "#F7F7F7" : "#FFFFFF",
        fontSize: 14,
      }}
    >
      {/* Name */}
      <div style={{ flex: 2 }}>
        <div style={{ fontWeight: 500 }}>{template.name}</div>
        <div style={{ fontSize: 12, color: "#8A8A8A" }}>
        </div>
      </div>

      {/* Body */}
      <div style={{ flex: 4, fontSize: 13, color: "#555" }}>
        {template.templateBody}
      </div>

      {/* Template ID */}
      <div style={{ flex: 2, fontSize: 12 }}>
        {template.templateId || 'N/A'}
      </div>

      {/* Type */}
      {!isVoiceCall && (
        <div style={{ width: 90, fontSize: 13 }}>
          {isWhatsApp
            ? template.templateContentType
            : isSMS
              ? template.messageType
              : "N/A"}
        </div>
      )}
      {/* language */}
      {isVoiceCall && (
        <div style={{ width: 90, fontSize: 13 }}>
          {languageLabel}
        </div>
      )}
      {/* Action */}
      <div style={{ width: 90, textAlign: "right" }}>
        <Button
          size="xs"
          color="primary"
          style={{ borderRadius: 20 }}
          onClick={() => onEdit(template)}
        >
          Edit
        </Button>
      </div>
    </div>
  );
};

export default TemplateListItem;